import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { ReactComponent as ArrowIcon } from "../../../assets/icons/arrow-down-dropdown.svg";
import { FILTER_ACTION_TYPE } from "../../../redux/actions-type";

const FilterByDropdown = ({ deviceType }) => {
  const dispatch = useDispatch();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const filterData = [
    {
      key: "start",
      name: "Başlama",
    },
    { key: "end", name: "Bitiş" },
  ];


  const [selectedType, setSelectedType] = useState(filterData[0]?.name);


  const handleClick = (item)=>{
     setSelectedType(item.name);   
  setDropdownOpen(false);  
    dispatch({type:FILTER_ACTION_TYPE.GET_FILTER_DATA,payload:{filterBy:item.key || "start"}})
  }

  return (
    <div
      className={`global-category-dropdown dropdown-name data-status ${deviceType} ${
        dropdownOpen ? "active" : ""
      }`}
    >
      <div
        className="dropdown-head"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <h2>{selectedType }</h2>
        <div className="arrow-icon">
          <ArrowIcon />
        </div>
      </div>

      <div className="dropdown-body">
        <ul>
          {filterData.map((item) => (
            <li key={item.key} onClick={() => handleClick(item)}>
                
              {item.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FilterByDropdown;
